export default __webpack_public_path__ + "static/media/exponent.0aa4889a.svg";